import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';

class photoSwipeHandler{
    
    constructor(gallerySelector){
        
        let galleryElements = document.querySelectorAll( gallerySelector );
        if(!galleryElements.length){
            return false;
        }
        
        this.appendTemplate();

        for(var i = 0, l = galleryElements.length; i < l; i++) {
            galleryElements[i].setAttribute('data-pswp-uid', i+1);
            galleryElements[i].onclick = (e)=>{this.onThumbnailsClick(e)};
        }

        // Parse URL and open gallery if it contains #&pid=3&gid=1
        let hashData = this.photoswipeParseHash();
        if(hashData.pid && hashData.gid) {
            this.openPhotoSwipe( hashData.pid ,  galleryElements[ hashData.gid - 1 ], true, true );
        }
    }
    
    // Add photoSwipe Template
    appendTemplate(){
        if(document.querySelectorAll('.pswp').length){
            return false;
        }
        let template = `<!-- Root element of PhotoSwipe. Must have class pswp. -->
        <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">

            <!-- Background of PhotoSwipe. 
                 It's a separate element as animating opacity is faster than rgba(). -->
            <div class="pswp__bg"></div>

            <!-- Slides wrapper with overflow:hidden. -->
            <div class="pswp__scroll-wrap">
                
                <!-- Container that holds slides. 
                    PhotoSwipe keeps only 3 of them in the DOM to save memory.
                    Don't modify these 3 pswp__item elements, data is added later on. -->
                <div class="pswp__container">
                    <div class="pswp__item"></div>
                    <div class="pswp__item"></div>
                    <div class="pswp__item"></div>
                </div>

                <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->
                <div class="pswp__ui pswp__ui--hidden">
                    
                    
                    <!-- Preloader demo http://codepen.io/dimsemenov/pen/yyBWoR -->
                    <!-- element will get class pswp__preloader--active when preloader is running -->
                    <div class="pswp__preloader">
                        <div class="pswp__preloader__icn">                          
                        </div>
                    </div>

                    <div class="pswp__top-bar">

                        <!--  Controls are self-explanatory. Order can be changed. -->

                        <div class="pswp__counter"></div>

                        <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>

                        <button class="pswp__button pswp__button--share" title="Share"></button>

                        <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>

                        <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>

                        
                    </div>

                    <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
                        <div class="pswp__share-tooltip"></div> 
                    </div>

                    <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
                    </button>

                    <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
                    </button>

                    <div class="pswp__caption">
                        <div class="pswp__caption__center"></div>
                    </div>

                </div>

            </div>

        </div>`;
        let wrapper = document.createElement('div');
        wrapper.innerHTML = template;
        document.body.appendChild(wrapper);
        return true;
    }
    // parse slide data (url, title, size ...) from DOM elements 
    // (children of gallerySelector)
    parseThumbnailElements(el){
        let thumbElements = el.childNodes,
            numNodes = thumbElements.length,
            items = [],
            figureEl,
            linkEl,
            size,
            item;
        
        for(var i = 0; i < numNodes; i++) {

            figureEl = thumbElements[i]; // <figure> element             
            // include only element nodes 
            if(figureEl.nodeType !== 1) {
                continue;
            }

            linkEl = figureEl.children[0]; // <a> element

            //size = linkEl.getAttribute('data-size').split('x');

            // create slide object
            item = {
                src: linkEl.getAttribute('href'),
                  w:0,
                  h:0
//                w: parseInt(size[0], 10),
//                h: parseInt(size[1], 10)
            };



            if(figureEl.children.length > 1) {
                // <figcaption> content
                item.title = figureEl.children[1].innerHTML; 
            }

            if(linkEl.children.length > 0) {
                // <img> thumbnail element, retrieving thumbnail url
                item.msrc = linkEl.children[0].getAttribute('src');
            } 

            item.el = figureEl; // save link to element for getThumbBoundsFn
            items.push(item);
        }

        return items;
    }
    
    onThumbnailsClick(e){
        e = e || window.event;
        e.preventDefault ? e.preventDefault() : e.returnValue = false;

        let eTarget = e.target || e.srcElement;

        // find root element of slide
        let clickedListItem = closest(eTarget, function(el) {
            return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
        });

        if(!clickedListItem) {
            return;
        }

        // find index of clicked item by looping through all child nodes
        // alternatively, you may define index via data- attribute
        let clickedGallery = clickedListItem.parentNode,
            childNodes = clickedListItem.parentNode.childNodes,
            numChildNodes = childNodes.length,
            nodeIndex = 0,
            index;

        for (let i = 0; i < numChildNodes; i++) {
            if(childNodes[i].nodeType !== 1) { 
                continue; 
            }

            if(childNodes[i] === clickedListItem) {
                index = nodeIndex;
                break;
            }
            nodeIndex++;
        }



        if(index >= 0) {
            // open PhotoSwipe if valid index found
            this.openPhotoSwipe( index, clickedGallery );
        }
        return false;
    };
    
    photoswipeParseHash(){
        let hash = window.location.hash.substring(1),
        params = {};

        if(hash.length < 5) {
            return params;
        }

        let vars = hash.split('&');
        for (var i = 0; i < vars.length; i++) {
            if(!vars[i]) {
                continue;
            }
            var pair = vars[i].split('=');  
            if(pair.length < 2) {
                continue;
            }           
            params[pair[0]] = pair[1];
        }

        if(params.gid) {
            params.gid = parseInt(params.gid, 10);
        }

        return params;
    }
    
    
    
    openPhotoSwipe(index, galleryElement, disableAnimation, fromURL){
        let pswpElement = document.querySelectorAll('.pswp')[0],
            gallery,
            options,
            items;

        items = this.parseThumbnailElements(galleryElement);

        // define options (if needed)
        options = {

            // define gallery index (for URL)
            galleryUID: galleryElement.getAttribute('data-pswp-uid'),
            showHideOpacity:true,
            hideAnimationDuration:0,
            barsSize: {top:60, bottom:60},
            preload: [2,2],
            maxSpreadZoom: 1,
            closeOnScroll: false,
            loadingIndicatorDelay: 1,
            getDoubleTapZoom: function(isMouseClick, item) {
                    return item.initialZoomLevel;
            },
            pinchToClose: false,
            showAnimationDuration:0,
            clickToCloseNonZoomable: false,
            fullscreenEl: false,
            zoomEl: false,
            shareEl: false,
            counterEl: false,
            /*
            getThumbBoundsFn: function(index) {
                // See Options -> getThumbBoundsFn section of documentation for more info
                //let thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
                //    pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                //    rect = thumbnail.getBoundingClientRect(); 

                //return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
            }
            */

        };

        // PhotoSwipe opened from URL
        if(fromURL) {
            if(options.galleryPIDs) {
                // parse real index when custom PIDs are used 
                // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
                for(let j = 0; j < items.length; j++) {
                    if(items[j].pid == index) {
                        options.index = j;
                        break;
                    }
                }
            } else {
                // in URL indexes start from 1
                options.index = parseInt(index, 10) - 1;
            }
        } else {
            options.index = parseInt(index, 10);
        }

        // exit if index not found
        if( isNaN(options.index) ) {
            return;
        }

        if(disableAnimation) {
            options.showAnimationDuration = 0;
        }

        // Pass data to PhotoSwipe and initialize it
        gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default , items, options);
        gallery.listen('gettingData', function(index, item) {
            if (item.w < 1 || item.h < 1) { // unknown size
            var img = new Image(); 
            img.onload = function() { // will get size after load
            item.w = this.width; // set image width
            item.h = this.height; // set image height
               gallery.invalidateCurrItems(); // reinit Items
               gallery.updateSize(true); // reinit Items
            }
                img.src = item.src; // let's download image
            }
        });
        gallery.init();
    }
    
}

let closest = (el, fn)=> {
        return el && ( fn(el) ? el : closest(el.parentNode, fn) );
};

new photoSwipeHandler('.gallery-container');


class photoSingleSwipeHandler extends photoSwipeHandler {
   
    constructor(gallerySelector){
        super();
        let galleryElements = document.querySelectorAll( gallerySelector );
        if(!galleryElements.length){
            return false;
        }
        
        this.appendTemplate();
        for(var i = 0, l = galleryElements.length; i < l; i++) {         
            galleryElements[i].onclick = (e)=>{this.onThumbnailsClick(e)};
        }
    }
    onThumbnailsClick(e){
        e = e || window.event;
        e.preventDefault ? e.preventDefault() : e.returnValue = false;

        let eTarget = e.target || e.srcElement;
        
        let clickedListItem = closest(eTarget, function(el) {
            return (el.tagName && el.tagName.toUpperCase() === 'A');
        });
        
        
        this.openPhotoSwipe(clickedListItem);
    }
    
    openPhotoSwipe(el){
        let pswpElement = document.querySelectorAll('.pswp')[0],            
            options,
            gallery,
            items;
    
            items = this.parseThumbnailElements(el);
            
            options = {

                // define gallery index (for URL)
                //galleryUID: galleryElement.getAttribute('data-pswp-single-uid'),
                galleryPIDs: false,
                showHideOpacity:true,
                hideAnimationDuration:0,
                barsSize: {top:60, bottom:60},                
                maxSpreadZoom: 1,
                closeOnScroll: false,
                loadingIndicatorDelay: 1,
                getDoubleTapZoom: function(isMouseClick, item) {
                        return item.initialZoomLevel;
                },
                pinchToClose: false,
                showAnimationDuration:0,
                clickToCloseNonZoomable: false,
                fullscreenEl: false,
                zoomEl: false,
                shareEl: false,
                counterEl: false,               
            };
            
            gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default , items, options);
            
            gallery.listen('gettingData', function(index, item) {
                if (item.w < 1 || item.h < 1) { // unknown size
                var img = new Image(); 
                img.onload = function() { // will get size after load
                item.w = this.width; // set image width
                item.h = this.height; // set image height
                   gallery.invalidateCurrItems(); // reinit Items
                   gallery.updateSize(true); // reinit Items
                }
                    img.src = item.src; // let's download image
                }
            });
            gallery.init();
    }
    
    parseThumbnailElements(el){
        return [{
                src: el.getAttribute('href'),
                w:0,
                h:0
            }];            
    }
        
    
}

new photoSingleSwipeHandler('.single-swipper');





// WEBPACK FOOTER //
// ./assets/src/js/modules/photoswipe.js